export const SET_BLOCKRULE = "setBockrule";
export const CLEAR_BLOCKRULE = "clearBlockrule";
export const SET_BLOCKRULES = "setBlockrules";
export const CLEAR_BLOCKRULES = "clearBlockrules";
export const SET_TOTAL_BLOCKRULES = "setTotalBlockrules";
export const CLEAR_TOTAL_BLOCKRULES = "clearTotalBlockrules";
export const REMOVE_BLOCKRULE = "removeBlockrule";
export const SET_FIELD = "setField";
export const SET_CUSTOMERS_BLOCKED = "setCustomersBlocked";
export const CLEAR_CUSTOMERS_BLOCKED = "clearCustomersBlocked";
export const SET_TOTAL_CUSTOMERS_BLOCKED = "setTotalCustomersBlocked";
export const CLEAR_TOTAL_CUSTOMERS_BLOCKED = "clearTotalCustomersBlocked";
